<template>
    <div>
        <div id="content">
            <div class="menu-bar">
                <a class="btn link-green" @click="getDevirs()">
                    <i class="fa fa fa-sync"></i>
                    Devir Notunu Yenile
                </a>
                <a
                    class="btn btn-blue"
                    v-show="devir.length"
                    @click="printDevir()"
                >
                    <i class="fa fa fa-print"></i>
                    Yazdır
                </a>
            </div>
            <DevirModal
                v-if="editingDevir"
                :selectedPatient="selectedPatient"
                path="servis/"
                @close="closeDevir()"
                @save="saveDevir()"
            ></DevirModal>

            <div class="p-devir">
                <div class="large-empty" v-if="!devir.length">
                    <i class="fa fa-info-circle fa-3x"></i>
                    <span>Serviste Yatan Hasta Yok</span>
                </div>
                <div id="pra-devir" class="page">
                    <div class="b-tarih" v-if="devir.length">
                        {{ new Date() | moment("DD MMMM YYYY") }}
                    </div>
                    <div
                        v-for="(d, i) in patients"
                        :key="d.id"
                        class="hasta card-click"
                        @click="user.level == 1 ? editDevir(d.id) : ''"
                    >
                        <div class="top-devir">
                            <div class="no">{{ i + 1 }}</div>
                            <div class="name">
                                <span>
                                    <b>{{ d.name }}</b>
                                </span>
                                <span class="details">
                                    {{ d.sex | toSex }}, {{ d.birth | toYas }},
                                    {{ d.kg }} KG ({{ d.kilop }})
                                </span>
                            </div>
                            <div class="oda">
                                {{ servis(d.yeri) }} - {{ d.oda }}
                            </div>
                        </div>
                        <p>
                            TANI :
                            <b>{{ d.tanilar }}</b>
                        </p>
                        <p>
                            YATIŞ :
                            <b>{{ d.yatis | toGun }}</b>
                        </p>
                        <p>
                            <b>ALDIĞI TEDAVİLER</b>
                        </p>
                        <ul>
                            <li v-for="t in d.tedavi" :key="t.id">
                                {{ t.tedavi }}
                                {{ t.doz != "" ? "(" + t.doz + ")" : "" }}
                                <b>{{ (t.gun == 1 ? t.tarih : "") | toGun }}</b>
                            </li>
                        </ul>
                        <p>
                            {{ d.devir }}
                        </p>
                        <p>
                            <u><b>TAKİPLER VE PLAN</b></u>
                        </p>
                        <p>
                            <b>{{ d.plan }}</b>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from "qs";
import _ from "lodash";
import DevirModal from "../components/DevirModalServis.vue";
export default {
    name: "Devir",
    components: {
        DevirModal,
    },
    data() {
        return {
            editingDevir: false,
            selectedPatient: [],
            tedavi: {
                mode: 0,
                veri: {},
            },
        };
    },
    computed: {
        patients() {
            var result = _.chain(this.devir).orderBy("oda").value();
            return result;
        },
        devir() {
            return this.$store.getters.getPatients.servis;
        },
        user() {
            return this.$store.getters.getUser;
        },
    },
    methods: {
        servis(id) {
            return this.$store.getters.getServisKisa(id);
        },
        editDevir(id) {
            this.editingDevir = true;
            this.selectedPatient = this.devir.find((t) => t.id === id);
        },
        closeDevir() {
            this.editingDevir = false;
            this.selectedPatient = [];
        },
        saveDevir() {
            var veri = JSON.parse(JSON.stringify(this.selectedPatient));
            veri.q = "devir";
            this.$http({
                method: "post",
                url: "api/edit-patient.php",
                data: qs.stringify(veri),
            }).then(() => {
                this.$snotify.success("Devir notu başarıyla güncellendi");
                this.$socket.client.emit("update", "patients");
                this.editingDevir = false;
                this.getDevirs();
            });
        },
        gunFarki(b1, b2) {
            var days = this.$moment(b2).diff(this.$moment(b1), "days", true);
            return Math.round(days) + ".GÜN";
        },
        printDevir() {
            const options = {
                name: "_blank",
                specs: [
                    "height=800",
                    "height=800",
                    "titlebar=yes",
                    "scrollbars=yes",
                ],
                styles: ["https://pediatrim.net/print/devir.css"],
            };
            this.$htmlToPaper("pra-devir", options);
        },
        getDevirs() {
            this.$store.dispatch("fillPatients");
        },
    },
};
</script>

<style lang="scss">
</style>